import { render, staticRenderFns } from "./StepMiddlewareConfigV2.vue?vue&type=template&id=4b0697aa"
import script from "./StepMiddlewareConfigV2.vue?vue&type=script&lang=js"
export * from "./StepMiddlewareConfigV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports